import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { logger } from '../../../common/utils/logger';

export const onConvoStartersFailed = (props: {
	analyticsAttributes: any;
	error: string;
}): AnalyticsEventPayload => {
	try {
		return {
			action: 'failed',
			actionSubject: 'aiConvoStarters',
			eventType: 'track',
			attributes: {
				...props.analyticsAttributes,
				error: props.error,
			},
		};
	} catch (error) {
		logger.error({
			feature: 'sain-text-answer',
			element: 'followup-buttons',
			operation: 'build-analytics',
			category: 'invariant',
			telemetryOnly: true,
			error,
			functionName: 'onConvoStartersFailed',
		});
		return {};
	}
};
